<svg width="100%"
     height="100%"
     viewBox="0 0 48 48"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
        <circle cx="21.7419"
                cy="21.7419"
                r="7.74192"
                stroke="currentColor"
                stroke-width="2.3"
                stroke-linecap="round" />
        <path d="M28.1936 28.1936L34 34"
              stroke="currentColor"
              stroke-width="2.3"
              stroke-linecap="round"
              stroke-linejoin="round" />
</svg>